import { PasswordInput } from "@mantine/core";

const MantinePasswordInput = (props: any) => {
  const { label, placeholder, value, onChange, error,classNames } = props;
  return (
    <PasswordInput
      classNames={classNames}
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      error={error}
      autoComplete="off"
    />
  );
};

export default MantinePasswordInput;
